export const LEARNING_HUB_URL = 'https://kb.flair.hr';
